import Vue from 'vue'
import Drawer from '@/components/core/Drawer'
import Toolbar from '@/components/core/Toolbar'
import Events from '@/components/core/Events'
import Loader from '@/components/base/Loader'
import BaseInput from '@/components/base/Input'
import NavBase from '@/components/base/NavBase'
import InfoBase from '@/components/base/InfoBase'
import BaseInputNumber from '@/components/base/InputNumber'
import BaseCalendar from '@/components/base/InputCalendar'
import BaseInputSelect from '@/components/base/InputSelect'
import BaseTextArea from '@/components/base/TextArea'
import VerticalCard from '@/components/base/VerticalCard'
import CourseCard from '@/components/Curso/CourseCard'
import UnityDialog from '@/components/Unidad/UnityDialog'
import SENCEForm from '@/components/SENCE/Form'
import LessonArchives from '@/components/Leccion/Archives'
import LessonLinks from '@/components/Leccion/Links'
import LessonRecording from '@/components/Leccion/Recording'
import ScheduleMeeting from '@/components/Leccion/ScheduleMeeting'

Vue.component("CoreDrawer", Drawer);
Vue.component("CoreToolbar", Toolbar);
Vue.component("CoreEvents", Events);
Vue.component("BaseInput", BaseInput);
Vue.component("BaseInputNumber", BaseInputNumber);
Vue.component("BaseCalendar", BaseCalendar);
Vue.component("BaseInputSelect", BaseInputSelect);
Vue.component("BaseTextArea", BaseTextArea);
Vue.component("Loader", Loader);
Vue.component("InfoBase", InfoBase);
Vue.component("NavBase", NavBase);
Vue.component("CourseCard", CourseCard);
Vue.component("UnityDialog", UnityDialog);
Vue.component("VerticalCard", VerticalCard);
Vue.component("SENCEForm", SENCEForm);
Vue.component("LessonLinks", LessonLinks);
Vue.component("LessonRecording", LessonRecording);
Vue.component("LessonArchives", LessonArchives);
Vue.component("ScheduleMeeting", ScheduleMeeting);



// WEBPACK FOOTER //
// ./src/components/index.js